<template>
   <v-layout pa-4 >                                                
        <v-flex xs12>                                         
            <v-text-field
                @keyup="search(vm)"
                v-model="searchMixin.searchText"
                prepend-inner-icon="fas fa-search"
                dense
                label="Zoek een gebruiker"
                solo>                    
            </v-text-field>
            <v-pagination v-if="userPagination.count > 0"
                v-model="userPagination.current_page"
                :length="userPagination.total_pages"                           
                @input="loadPage">
            </v-pagination>                      
            <v-list two-line>
                <v-list-tile v-for="user in users" :key="user.id" @click="selectUser(user)">
                    <v-list-tile-avatar>
                        <dd-avatar :user="user"></dd-avatar>
                    </v-list-tile-avatar>            
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${user.person.lastName}, ${user.person.firstName}`"></v-list-tile-title>                                
                        <v-list-tile-sub-title v-html="user.email"></v-list-tile-sub-title>                                
                    </v-list-tile-content>
                    <v-chip v-if="!user.active" color="red" dark label small outline>inactief</v-chip>
                </v-list-tile>                       
            </v-list>            
            <v-pagination v-if="userPagination.count > 0"             
                v-model="userPagination.current_page"
                :length="userPagination.total_pages"                           
                @input="loadPage">
            </v-pagination>                            
        </v-flex>                                
    </v-layout>
</template>

<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import DdAvatar from "../../components/global/DdAvatar"    
    import Notification from "../../components/global/Notification"
    import SearchWithPagerMxin from "../../plugins/mixins/SearchWithPagerMixin"

    export default {
        mixins:[SearchWithPagerMxin],
        components:{
            DdAvatar,
            Notification
        },       
        data() {            
            return {}
        },
        computed: {
            ...mapGetters({
                users: types.USERS,
                userRoles: types.USER_ROLES,
                userPagination: types.USERS_PAGINATION
            }),
            userActive(){
                return this.selectedUser.active ? "Account actief" : "Account inactief"
            }
        },    
        methods: {
            selectUser(user) {
                this.$emit("userFound", user)
            } 
        },        
        mounted(){
            // configure mixin
            this.searchMixin.payloadData     = {}
            this.searchMixin.payloadIncludes = "person.address,avatar,roles"
            this.searchMixin.searchStore     = types.USERS_SEARCH
            this.searchMixin.defaultStore    = types.USERS
            this.searchMixin.perPage         = 5

            this.reset()
            if(this.userRoles.length == 0){
                this.$store.dispatch(types.USER_ROLES,{});       
            }     
               
        },             
    }
</script>

<style lang="scss" scoped>

</style>